import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { Card, useBreakpoint } from '@hh.ru/magritte-ui';
import { AstrostarOutlinedSize16, FolderOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import { useCalculatorContext } from 'src/pages/Profession/components/SectionCalculator/Context';

import ItemContainer from 'src/pages/Profession/components/SectionCalculator/Calculator/CalculatorTablo/ItemContainer';
import ItemSalary from 'src/pages/Profession/components/SectionCalculator/Calculator/CalculatorTablo/ItemSalary';
import ItemVacancies from 'src/pages/Profession/components/SectionCalculator/Calculator/CalculatorTablo/ItemVacancies';

import styles from 'src/pages/Profession/components/SectionCalculator/Calculator/CalculatorTablo/styles.less';

const CalculatorTablo: TranslatedComponent = () => {
    const { tablo } = useCalculatorContext();
    const { isInitial, isLoading, data } = tablo;
    const { salary, vacancies } = data;
    const { isXS, isS } = useBreakpoint();
    const isMobile = isXS || isS;

    return (
        <Card borderRadius={isMobile ? 16 : 24} style="extra-1" data-qa="calculator-tablo">
            <div className={styles.content}>
                <ItemContainer loading={isLoading} icon={<FolderOutlinedSize16 initial="contrast" />}>
                    <ItemSalary init={isInitial} value={salary.payBasedOnSkills} total={salary.payTotal} />
                </ItemContainer>
                <ItemContainer loading={isLoading} icon={<AstrostarOutlinedSize16 initial="contrast" />}>
                    <ItemVacancies init={isInitial} count={vacancies.count} link={vacancies.link} />
                </ItemContainer>
            </div>
        </Card>
    );
};

export default translation(CalculatorTablo);
